module.exports = __webpack_public_path__ + "static/media/root_to_crown_logo.af2f2b69.png";